<template>
  <div>
    <v-dialog :value="true" transition="none" max-width="800" @click:outside="closeDialog">
      <v-card v-html="text" class="pa-5" />
      <v-btn icon class="close-icon" @click="closeDialog"><v-icon>mdi-close-thick</v-icon></v-btn>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'ViewText',

  props: {
    text: {
      type: String,
      required: true,
    },
  },

  methods: {
    closeDialog() {
      this.$emit('click:close');
    },
  },
};
</script>

<style scoped>
.close-icon {
  color: white !important;
  position: fixed;
  top: 0;
  right: 0;
  margin: 25px;
}
</style>
